
export const cardsData = [
    {
        id: 1,
        title: 'Cool Investor',
        amount: '1,250,000',
        percentage: '5%',
        off: '0.2%',
        color: 'blue'
    },
    {
        id: 2,
        title: 'Warm Investor',
        amount: '2,800,000',
        percentage: '20%',
        off: '0.5%',
        color: 'blue'
    },
    {
        id: 3,
        title: 'Hot Investor',
        amount: '15,000,000',
        percentage: '50%',
        off: '1.2%',
        color: 'blue'
    },
    {
        id: 4,
        title: 'Small Investor',
        amount: '$300 BUSD',
        percentage: '5%',
        off: null,
        color: 'green'
    },
    {
        id: 5,
        title: 'Classic Investor',
        amount: '$1,000 BUSD',
        percentage: '20%',
        off: null,
        color: 'green'
    }
]